import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import isFunction from 'lodash/isFunction';
import isEqual from 'lodash/isEqual';
import classNames from 'classnames';
import AirModalTitlebar from '../../../../../common/components/AirModalTitlebar';
import AirInput from '../../../../../common/components/AirInput';
import { UserAddIcon, UserIcon } from '../../../../../common/icons';
import { Checkbox, Select, Spin } from 'antd';
import AirButton from '../../../../../common/components/AirButton';
import AirSelectWithLabel from '../../../../../common/components/AirSelectWithLabel';

import './DriverModal.css';

const { Option } = Select;

const DriverModalSection = ({ children, title, titleSuffix, ...props }) => (
  <div {...props} className={`DriverModalSection${props.className ? ` ${props.className}` : ''}`}>
    <div className="SectionTitle">{title}<Fragment>{titleSuffix}</Fragment></div>
    <div className="SectionContent">{children}</div>
  </div>
);

@inject('translationsStore', 'driversStore', 'commonStore')
@observer
export default class DriverModal extends Component {
  constructor(props) {
    super(props);
    this.defaultDriverDataValues = {
      name: undefined,
      surname: undefined,
      uin: undefined,
      mobile: undefined,
      email: undefined,
      vehicle: undefined,
      extra: []
    };
    this.optionsDriverExtras = [
      {
        label: this.props.translationsStore.translate('driversManager.addDriver.modal.sectionDriverExtraOptions.labeluserCanLogin'),
        value: 'userCanLogin'
      }
    ];
    this.state = {
      loadingResources: false,
      ...this.defaultDriverDataValues
    };
  }

  componentDidMount = () => {
    this.loadResources(this.props.data);
  };

  componentDidUpdate = prevProps => {
    if (!isEqual(this.props.data, prevProps.data)) {
      this.loadResources(this.props.data);
    }
  };

  loadResources = data => {
    this.setState({ loadingResources: true });
    if (data === undefined) {
      this.setState({ ...this.defaultDriverDataValues, loadingResources: false });
    } else {
      this.setState({
        name: data.name,
        surname: data.surname,
        uin: data.uin,
        mobile: data.mobile,
        email: data.email,
        vehicle: data.assignedVehicle,
        extra: data.login && data.login !== '' ? ['userCanLogin'] : [],
        loadingResources: false
      });
    }
  };

  onNameChange = e => {
    this.setState({
      name: e.target.value
    });
  };

  onSurnameChange = e => {
    this.setState({
      surname: e.target.value
    });
  };

  onUinChange = e => {
    this.setState({
      uin: String(e.target.value).toUpperCase()
    });
  };

  onMobileChange = e => {
    this.setState({
      mobile: e.target.value
    });
  };

  onEmailChange = e => {
    this.setState({
      email: e.target.value
    });
  };

  onPlateChange = vehicle => {
    this.setState({ vehicle: JSON.parse(vehicle) });
  };

  onMakeChange = e => {
    this.setState({
      make: e.target.value
    });
  };

  onModelChange = e => {
    this.setState({
      model: e.target.value
    });
  };

  onDriverExtrasChange = extra => {
    this.setState({
      extra
    });
  };

  onClearVehicle = () => {
    this.setState({ vehicle: undefined });
  };

  handleCancel = () => {
    isFunction(this.props.onCancel) && this.props.onCancel();
  };

  handleSave = () => {
    this.setState({ loadingResources: true });
    const { driversStore } = this.props;
    const { data: { uin } = {} } = this.props;
    const data = {
      name: this.state.name,
      surname: this.state.surname,
      uin: this.state.uin,
      mobile: this.state.mobile,
      email: this.state.email,
      vehicle: this.state.vehicle,
      extra: this.state.extra
    };

    driversStore
      .saveDriver(uin, data)
      .then(response => {
        this.setState({ ...this.defaultDriverDataValues }, () => {
          isFunction(this.props.onDone) && this.props.onDone();
        });
      })
      .catch(error => {
        if (error.type) {
          const { translationsStore } = this.props;
          this.setState({ modalError: translationsStore.translate(`driversManager.addDriver.modal.errors.${error.type}`), visibleModalError: true });
        } else {
          const message = error.errors && error.errors[0] && error.errors[0].message ? error.errors[0].message : error.message ? error.message : undefined;
          if (message) {
            this.setState({ modalError: message, visibleModalError: true });
          }
        }
      })
      .finally(() => this.setState({ loadingResources: false }));
  };

  handleSaveAndCreateNew = () => {
    this.setState({ loadingResources: true });
    const { driversStore } = this.props;
    const { data: { uin } = {} } = this.props;
    const data = {
      name: this.state.name,
      surname: this.state.surname,
      uin: this.state.uin,
      mobile: this.state.mobile,
      email: this.state.email,
      vehicle: this.state.vehicle,
      extra: this.state.extra
    };
    driversStore
      .saveDriver(uin, data)
      .then(response => {
        this.setState({ ...this.defaultDriverDataValues });
      })
      .catch(error => {
        if (error.type) {
          const { translationsStore } = this.props;
          this.setState({ modalError: translationsStore.translate(`driversManager.addDriver.modal.errors.${error.type}`), visibleModalError: true });
        } else {
          const message = error.errors && error.errors[0] && error.errors[0].message ? error.errors[0].message : error.message ? error.message : undefined;
          if (message) {
            this.setState({ modalError: message, visibleModalError: true });
          }
        }
      })
      .finally(() => this.setState({ loadingResources: false }));
  };

  render() {
    const { translationsStore, driversStore, vehicleCanBeUnassigned } = this.props;
    const { loadingResources } = this.state;
    let optionsDriverExtrasProps = {};
    if (this.props.data && this.props.data.login && this.props.data.login !== '') {
      optionsDriverExtrasProps = { disabled: true };
    }
    let { availableVehiclesForAssignment } = driversStore;
    const assignedPlates = driversStore.drivers.filter(driver => driver.assignedVehicle !== undefined).map(driver => driver.assignedVehicle.plate);
    availableVehiclesForAssignment = availableVehiclesForAssignment.filter(vehicle => !assignedPlates.includes(vehicle.plate));
    const cls = classNames({
      DriverModal: true
    });
    const title = translationsStore.translate(!!this.props.data ? 'driversManager.addDriver.modal.titleEdit' : 'driversManager.addDriver.modal.titleCreate');
    const validName = (this.state.name || '').trim().length > 1;
    const clsName = classNames({
      withError: !validName
    });
    const validSurname = (this.state.surname || '').trim().length > 1;
    const clsSurname = classNames({
      withError: !validSurname
    });
    const validUin = /^([0-9]{11}|[A-Z]{6}[0-9]{2}[A-Z][0-9]{2}[A-Z][0-9]{3}[A-Z])$/.test((this.state.uin || '').toUpperCase());
    const clsUin = classNames({
      withError: !validUin
    });
    const validMobile = /^[0-9]{9,10}$/.test(this.state.mobile);
    const clsMobile = classNames({
      withError: !validMobile
    });
    const validEmail = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/.test(
      this.state.email
    );
    const clsEmail = classNames({
      withError: !validEmail
    });
    const canBeSaved = validName && validSurname && validUin && validMobile && validEmail;
    return (
      <Fragment>
        <AirModalTitlebar
          className={cls}
          visible={this.props.hasOwnProperty('visible') ? this.props.visible : true}
          onCancel={this.handleCancel}
          title={title}
          titlebarStyle={{ color: 'white', backgroundColor: 'var(--selected-color)' }}
          buttonsStyle={{ display: 'none' }}
          width={900}
        >
          <Spin spinning={loadingResources}>
            <div className="DriverModalWrapper">
              <div className="DriverModalIntro">
                {!!this.props.data ? <UserIcon style={{ width: '42px', height: '42px' }} /> : <UserAddIcon style={{ width: '42px', height: '42px' }} />}
              </div>
              <DriverModalSection title={translationsStore.translate('driversManager.addDriver.modal.sectionDriverData.title')}>
                <AirInput
                  className={clsName}
                  label={translationsStore.translate('driversManager.addDriver.modal.sectionDriverData.labelName')}
                  value={this.state.name}
                  onChange={this.onNameChange}
                />
                <AirInput
                  className={clsSurname}
                  label={translationsStore.translate('driversManager.addDriver.modal.sectionDriverData.labelSurname')}
                  value={this.state.surname}
                  onChange={this.onSurnameChange}
                />
                <AirInput
                  className={clsUin}
                  label={translationsStore.translate('driversManager.addDriver.modal.sectionDriverData.labelUin')}
                  value={this.state.uin}
                  onChange={this.onUinChange}
                />
                <AirInput
                  className={clsMobile}
                  label={translationsStore.translate('driversManager.addDriver.modal.sectionDriverData.labelMobile')}
                  value={this.state.mobile}
                  onChange={this.onMobileChange}
                />
                <AirInput
                  className={clsEmail}
                  label={translationsStore.translate('driversManager.addDriver.modal.sectionDriverData.labelEmail')}
                  value={this.state.email}
                  onChange={this.onEmailChange}
                />
                <div />
              </DriverModalSection>
              <DriverModalSection
                title={translationsStore.translate('driversManager.addDriver.modal.sectionAssignedVehicle.title')}
                titleSuffix={<div className={`button${!vehicleCanBeUnassigned ? ' disabled': ''}`} onClick={() => {vehicleCanBeUnassigned && this.onClearVehicle()}}>{translationsStore.translate('driversManager.addDriver.modal.sectionAssignedVehicle.labelActionUnassign')}</div>}
              >
                <AirSelectWithLabel
                  label={translationsStore.translate('driversManager.addDriver.modal.sectionAssignedVehicle.labelPlate')}
                  onChange={this.onPlateChange}
                  value={this.state.vehicle ? this.state.vehicle.plate : ''}
                  dropdownMatchSelectWidth={false}
                >
                  {availableVehiclesForAssignment.map(vehicle => (
                    <Option key={vehicle.vin} value={JSON.stringify(vehicle)}>
                      {vehicle.plate}
                    </Option>
                  ))}
                </AirSelectWithLabel>
                <AirInput
                  label={translationsStore.translate('driversManager.addDriver.modal.sectionAssignedVehicle.labelMake')}
                  value={
                    this.state.vehicle && this.state.vehicle.hasOwnProperty('make') && this.state.vehicle.make.hasOwnProperty('descrizione')
                      ? this.state.vehicle.make.descrizione
                      : ''
                  }
                  readOnly
                />
                <AirInput
                  label={translationsStore.translate('driversManager.addDriver.modal.sectionAssignedVehicle.labelModel')}
                  value={
                    this.state.vehicle && this.state.vehicle.hasOwnProperty('model') && this.state.vehicle.model.hasOwnProperty('descrizione')
                      ? this.state.vehicle.model.descrizione
                      : ''
                  }
                  readOnly
                />
              </DriverModalSection>
              {this.optionsDriverExtras && this.optionsDriverExtras.length > 0 && (
                <DriverModalSection title={translationsStore.translate('driversManager.addDriver.modal.sectionDriverExtraOptions.title')}>
                  <div>
                    <Checkbox.Group options={this.optionsDriverExtras} onChange={this.onDriverExtrasChange} value={this.state.extra} {...optionsDriverExtrasProps} />
                  </div>
                </DriverModalSection>
              )}
              <div className="DriverModalActions">
                <AirButton
                  className="ActionSave"
                  size="large"
                  light="true"
                  label={translationsStore.translate('driversManager.addDriver.modal.actionSave')}
                  onClick={this.handleSave}
                  disabled={!canBeSaved}
                  bgcolor={canBeSaved ? `var(--primary-color)` : `var(--grey)`}
                />
                {!this.props.data && (
                  <AirButton
                    className="ActionSaveAndCreateNew"
                    size="large"
                    light="true"
                    label={translationsStore.translate('driversManager.addDriver.modal.actionSaveAndCreateNew')}
                    onClick={this.handleSaveAndCreateNew}
                    disabled={!canBeSaved}
                    bgcolor={canBeSaved ? `var(--primary-color)` : `var(--grey)`}
                  />
                )}
              </div>
            </div>
          </Spin>
        </AirModalTitlebar>
        <AirModalTitlebar
          visible={this.state.visibleModalError}
          okButton={<AirButton size="large" light="true" label={'Ok'} style={{ marginLeft: 20, width: 240 }} />}
          onOk={() => this.setState({ modalError: undefined, visibleModalError: false })}
          title={translationsStore.translate('driversManager.addDriver.modal.titleErrorOnSave')}
          titlebarStyle={{ color: 'white', backgroundColor: 'var(--red-dtc-color)' }}
          buttonsStyle={{ justifyContent: 'center' }}
          width={300}
        >
          <div style={{ margin: 14 }}>
            {translationsStore.translate('driversManager.addDriver.modal.labelErrorOnSave')}
            <br />
            {this.state.modalError}
          </div>
        </AirModalTitlebar>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/DriversManagerDashboard/SelectableDrivers/DriverModal/DriverModal.js